import { Link, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { API_URL } from "../config/api";


export const EventDetails = () => {

    const { slug } = useParams();

    const [event, setEvent] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {

        axios
            .get(`${API_URL}/api/events/${slug}`)
            .then((response) => {

                setEvent(response.data);

            })
            .catch((error) => {

                console.log(error);

            })
            .finally(() => {

                setLoading(false);

            });

    }, [slug]);

    if (loading) {

        return (

            <div className="container py-5 text-center">

                <h4>Loading event...</h4>

            </div>

        );

    }

    if (!event) {

        return (

            <div className="container py-5 text-center">

                <h4>Event not found.</h4>

            </div>

        );

    }

    return (
        <>
            {/* Page Header */}

            <div className="container-fluid page-header py-5">

                <div className="container text-center py-5">

                    <h1 className="display-4 text-white">
                        {event.title}
                    </h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb justify-content-center mb-0 animated slideInDown">

                            <li className="breadcrumb-item">
                                <Link to="/">Home</Link>
                            </li>

                            <li className="breadcrumb-item">
                                <Link to="/events">Events</Link>
                            </li>

                            <li
                                className="breadcrumb-item text-white"
                                aria-current="page"
                            >
                                Events Details
                            </li>

                        </ol>
                    </nav>

                </div>

            </div>

            {/* Event Detail */}

            <div className="container py-5">

                <div className="row justify-content-center">

                    <div className="col-lg-10">

                        <div
                            className="mb-5"
                            style={{
                                height: "500px",
                                overflow: "hidden",
                                borderRadius: "10px"
                            }}
                        >

                            <img
                                src={event.featured_image}
                                alt={event.title}
                                className="w-100 h-100"
                                style={{
                                    objectFit: "cover"
                                }}
                            />

                        </div>

                        <div className="mb-3">

                            <span className="badge bg-primary me-2">

                                {
                                    event.category === "medical-camp"
                                        ? "Medical Camp"
                                        : event.category === "education-sitting"
                                        ? "Education Sitting"
                                        : "Health Awareness"
                                }

                            </span>

                            <span className="text-muted">

                                {event.event_date}

                            </span>

                        </div>

                        <h2 className="mb-4">

                            {event.title}

                        </h2>

                        <div
                        className="text-break"
                            dangerouslySetInnerHTML={{
                                __html: event.description
                            }}
                        />

                    </div>

                </div>

            </div>
        </>
    );
};